// React
import React, { useState } from "react";

// Components
import { Form, Container } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";

// EventifyAPI
import * as EventifyAPI from "../libs/EventifyAPI";

// AWS
import { Auth } from "aws-amplify";
import { GoogleLogin } from "react-google-login";
import config from "../config";

// Local Storage
import ls from "local-storage";

export default function LoginPage(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticatingGatsbyLogin, setIsAuthenticatingGatsbyLogin] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: ""
  });

  const [organizationid, setOrganizationid] = useState(null);

  function validateForm() {
    return fields.email.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await Auth.signIn(fields.email, fields.password);

      const authData = { providerType: "amazon", email: fields.email };

      const invitedUser = await EventifyAPI.getInvitedUserByEmail(fields.email);
      if (!invitedUser) {
        setIsLoading(false);
        return alert("You have not received an invite");
      }

      ls.set("authData", authData);
      // TODO: seems like organizationid needs to be stored somewhere in aws-amplify user object? or we need a global database of user<->org mappings
      // this whole system needs to be thought through a little more. as it stands, users can only be a member
      // of 1 org (and orgs are insecure and can be changed by altering localstorage)
      ls.set("organizationid", invitedUser.organizationId);

      props.userHasAuthData(authData);
      props.history.push("/");
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  const successResponseGoogle = async response => {
    // commented this out for now since it does not work
    // for the intrepid infra engineer to get AWS <> GMail to cooperate
    // Add the Google access token to the Cognito credentials login map.
    // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    //    IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
    //    Logins: {
    //       'accounts.google.com': authResult['id_token']
    //    }
    // });
    //
    // // Obtain AWS credentials
    // AWS.config.credentials.get(async function(){
    //   try {
    //     await Auth.currentSession();
    //     userHasAuthenticated(true);
    //   } catch (e) {
    //     if (e !== "No current user") {
    //       alert(e);
    //     }
    //   }
    // });
    //

    // TODO: consolidate w/ signup.js repeated code (auth lib?)
    // since this also signs a new user up if they don't exist in db yet, a check
    // is run server-side to see if they were invited (if user doesn't exist)
    setIsAuthenticatingGatsbyLogin(true);
    let result;
    try {
      result = await EventifyAPI.authenticateGoogleSignIn(response);
    } catch (err) {
      setIsAuthenticatingGatsbyLogin(false);
      alert(`Error: ${err.message}`)
    }

    setIsAuthenticatingGatsbyLogin(false);

    ls.set("authData", result.user);
    ls.set("organizationid", result.organizationId);

    props.userHasAuthData(result);
  };

  const failureResponseGoogle = response => {
    setIsAuthenticatingGatsbyLogin(false);
    alert(`Please contact developers. An error occurred: ${response}`)
  };

  return (
    <div className="Login">
      <img className="logo" src="logo.png" />
      <h1>Welcome to Eventify</h1>
      {!isAuthenticatingGatsbyLogin &&
        <form onSubmit={handleSubmit}>
          <Form.Group controlId="email" bssize="large">
            <Form.Label>Email</Form.Label>
            <Form.Control
              autoFocus
              type="email"
              value={fields.email}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="password" bssize="large">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={fields.password}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <LoaderButton
            block
            type="submit"
            bssize="large"
            isLoading={isLoading}
            disabled={!validateForm()}
          >
            Login
          </LoaderButton>
        </form>}
        {isAuthenticatingGatsbyLogin &&
          <h3>Logging in, please hold...</h3>
        }
        {!isAuthenticatingGatsbyLogin &&
          <h3>or</h3>
        }
        <GoogleLogin
          clientId="530469725356-el74ba1asc3g11dpc06ggn71skj4pq9c.apps.googleusercontent.com"
          buttonText="Login with Google"
          offline={false}
          onSuccess={successResponseGoogle}
          onFailure={failureResponseGoogle}
          cookiePolicy={"single_host_origin"}
        />
    </div>
  );
}
